import type { ReactElement, ReactNode } from "react";
import * as React from "react";
import "../globals.css";
import Providers from "@/services/providers/Providers";
import { Toaster } from "@/components/ui/sonner";
import ModalContainer from "@/features/Modals/ModalContainer";
import Head from "next/head";
import type { AppProps } from "next/app";
import type { NextPage } from "next";
import { AppCacheProvider } from "@mui/material-nextjs/v15-pagesRouter";
import { brandon_grotesque, lato, roboto } from "@/assets/fonts";
import { cn } from "@/lib/utils";

export type NextPageWithLayout<P = {}, IP = P> = NextPage<P, IP> & {
  getLayout?: (page: ReactElement) => ReactNode;
};

export type AppPropsWithLayout = AppProps & {
  Component: NextPageWithLayout;
};

export default function MyApp(props: AppPropsWithLayout) {
  const { Component, pageProps } = props;
  const getLayout = Component.getLayout || (page => page);

  return (
    <Providers>
      <AppCacheProvider {...pageProps}>
        <Head>
          <title>ExploreBC</title>
          <meta name="viewport" content="initial-scale=1, width=device-width" />
        </Head>
        <main
          id={"__main"}
          className={cn("antialiased", "font-roboto", brandon_grotesque.variable, lato.variable, roboto.variable)}
        >
          <ModalContainer />
          <Toaster />
          {getLayout(<Component {...pageProps} />)}
        </main>
      </AppCacheProvider>
    </Providers>
  );
}
